import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-items-center p-0"
}
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = {
  key: 0,
  class: "text-secondary"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "account-amount text-nowrap" }
const _hoisted_6 = { class: "d-flex flex-row align-items-center" }
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "on-hold" }
const _hoisted_9 = {
  key: 1,
  class: "correction"
}
const _hoisted_10 = {
  key: 2,
  class: "on-hold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_ctx.account)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showIcon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "account-currency-icon",
              src: _ctx.helper.currencyIcon(_ctx.account.currency),
              alt: _ctx.account.currency
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["account-sum", {'m-0': !_ctx.showIcon}])
        }, [
          (_ctx.showId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _withDirectives((_openBlock(), _createElementBlock("small", {
                  title: _ctx.account.id
                }, [
                  _createTextVNode(_toDisplayString(_ctx.account.id.substring(0, 8)), 1)
                ], 8, _hoisted_4)), [
                  [
                    _directive_b_tooltip,
                    void 0,
                    void 0,
                    { hover: true }
                  ]
                ]),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _createVNode(_component_copy_button, {
                  value: _ctx.account.id
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.account.sumWithoutInsurance)) + " " + _toDisplayString(_ctx.account.sumWithoutInsurance.currency), 1),
          _createElementVNode("div", _hoisted_6, [
            (!_ctx.hideInsurance && _ctx.account.insuranceLimitReach)
              ? _withDirectives((_openBlock(), _createElementBlock("small", {
                  key: 0,
                  class: "text-danger me-1",
                  title: _ctx.helper.trans('labels.insurance_warning', { sum: _ctx.numberFormatter.formatNumber(_ctx.account.insuranceLimitSum.amount, 2) + ' ' +  _ctx.account.insuranceLimitSum.currency})
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "fa fa-warning" }, null, -1)
                ]), 8, _hoisted_7)), [
                  [
                    _directive_b_tooltip,
                    void 0,
                    void 0,
                    { hover: true }
                  ]
                ])
              : _createCommentVNode("", true),
            (!_ctx.hideInsurance)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  style: {"font-size":"70%"},
                  class: _normalizeClass({'text-success': !_ctx.account.insuranceLimitReach, 'text-danger': _ctx.account.insuranceLimitReach})
                }, _toDisplayString(_ctx.helper.trans('labels.insurance_limit')) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.account.insuranceSum.amount, 2)) + " / " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.account.insuranceLimitSum.amount, 2)) + " " + _toDisplayString(_ctx.account.insuranceLimitSum.currency), 3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.helper.trans("dashboard.on_hold")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.account.frozenSum)) + " " + _toDisplayString(_ctx.account.sum.currency), 1),
          (_ctx.isAdmin && parseFloat(_ctx.account.correctionSum.amount) !== 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.helper.trans("dashboard.correction")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.account.correctionSum)) + " " + _toDisplayString(_ctx.account.sum.currency), 1))
            : _createCommentVNode("", true),
          (_ctx.account.externalDepositSum)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.helper.trans("dashboard.external_deposit")) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(_ctx.account.externalDepositSum)) + " " + _toDisplayString(_ctx.account.externalDepositSum?.currency), 1))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}